<template>
  <ul class="navigation clearfix">
    <slot name="menu"></slot>
    <MenuItem v-for="(item,index) in menuData" :key="index" :data="item" :node="{data: item, level: level}">
    <template v-if="item.children&&item.children.length>0">
      <SubMenu slot="subMenu" :data="item.children" :node="{data: item, level: level + 1}"></SubMenu>
    </template>
    </MenuItem>
  </ul>
</template>

<script>
import MenuItem from './menu-item'
import SubMenu from './sub-menu'
export default {
  components: {
    MenuItem,
    SubMenu
  },
  data () {
    return {
      menuData: [{
        name: this.$root.language.company,
        path: '/company',
        group: true,
        children: [{
          name: this.$root.language.whyJwi,
          path: '/company/why'
        },
        {
          name: this.$root.language.history,
          path: '/company/history'
        },
        {
          name: this.$root.language.careers,
          path: '/company/careers'
        }
        ]
      },

      {
        name: this.$root.language.technology,
        path: '/technology'
        // children: [{
        // name: this.$root.language.cloudNative,
        // path: '/technology/cloudNative'
        // },
        // {
        // name: this.$root.language.digitalThread,
        // path: '/technology/thread'
        // },
        // {
        // name: this.$root.language.smartApps,
        // path: '/technology/smartApps'
        // },
        // {
        // name: this.$root.language.edgeComputing,
        // path: '/technology/edgeComputing'
        // },
        // {
        // name: this.$root.language.twin,
        // path: '/technology/twin'
        // },
        // {
        // name: this.$root.language.analytics,
        // path: '/technology/analytics'
        // },
        // {
        // name: this.$root.language.iot,
        // path: '/technology/iot'
        // }
        // ]
      },

      {
        name: this.$root.language.solutions,
        path: '/solutions'
      },
      {
        name: this.$root.language.products,
        path: '/products',
        children: [{
          name: this.$root.language.platform,
          path: '/products/platform',
          group: true,
          children: [{
            name: this.$root.language.jicCloud,
            isAnchor: true,
            path: '/products/industryCloud'
          },
          {
            name: this.$root.language.devopsCloud,
            isAnchor: true,
            path: '/products/cloudPlatform'
          }
          ]
        },
        {
          name: this.$root.language.engineering,
          path: '/products/engineering',
          group: true,
          children: [{
            name: this.$root.language.navigator,
            isAnchor: true,
            path: '/products/navigator'
          },
          {
            name: this.$root.language.pdm,
            isAnchor: true,
            path: '/products/pdm'
          },
          {
            name: this.$root.language.ppm,
            isAnchor: true,
            path: '/products/ppm'
          },
          {
            name: this.$root.language.mpm,
            isAnchor: true,
            path: '/products/mpm'
          },
          {
            name: this.$root.language.npi,
            isAnchor: true,
            path: '/products/npi'
          }
          ]
        },
        {
          name: this.$root.language.factory,
          path: '/products/factory',
          group: true,
          children: [{
            name: this.$root.language.pqm,
            isAnchor: true,
            path: '/products/pqm'
          },
          {
            name: this.$root.language.deviceMate,
            isAnchor: true,
            path: '/products/deviceMate'
          },
          {
            name: this.$root.language.productionLineEngine,
            isAnchor: true,
            path: '/products/productionLine'
          }
          ]
        }
        ]
      },

      {
        name: this.$root.language.home,
        path: '/'
      }
      ]
    }
  },
  computed: {
    level () {
      return 0
    }
  },
  methods: {

  }
}

</script>

<style scoped>
  .navigation {
    margin-top: 5px;
  }

  ul {
    margin-top: 0;
    margin-bottom: 0em;
}

</style>
